import { Box, Button, Container, makeStyles, Typography } from '@material-ui/core';
import React, { useEffect } from 'react'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { startAlerta } from '../../../actions/ui/alertas';
import { finishSpinner, startSpinner } from '../../../actions/ui/spinner';
import { useForm } from '../../../hooks/useForm';
import AfiliadoService from '../../../services/AfiliadoService'

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%'
  },
  submit: {
    marginTop: "1rem",
    textTransform: 'none'
  },
  title: {
    fontWeight: "bold"
  }
}));

const SetEmailScreen = (props) => {
  const { history } = props
  const classes = useStyles()
  const dispatch = useDispatch()
  const { nroDocumento, fechaNacimiento } = useParams();

  const initialState = {
    email: "",
    confirmEmail: ""
  };

  const [formValues, handleInputChange] = useForm(initialState);
  const { email, confirmEmail } = formValues;

  const handleSelectDate = async (e) => {
    e.preventDefault();
    try {
      dispatch(startSpinner())
      const data = {
        nroDocumento,
        fechaNacimiento,
        email
      }

      const result = await AfiliadoService.setEmail(data)
      const body = await result.json()
      if (result.ok) {
        dispatch(finishSpinner())
        dispatch(startAlerta("¡Tu registro fue exitoso! Te enviaremos un correo electrónico con los datos de acceso.", "success"))
        history.push(`/afiliado/ingreso`)
      } else {
        throw body.errores
      }
    } catch (error) {
      dispatch(finishSpinner())
      if (error.mensaje) {
        dispatch(startAlerta(error.mensaje, "error"))
      } else {
        dispatch(startAlerta("Hubo un error al guardar tu correo electrónico y al registrarte. Intentalo nuevamente.", "error"))
      }
      console.log("Error al guardar email y registrar del usuario", error)
    }
  };

  useEffect(() => {
    // custom rule will have name 'isEmailMatch'
    ValidatorForm.addValidationRule('isEmailMatch', (value) => {
      if (value !== email) {
        return false;
      }
      return true;
    });
  })

  return (
    <div className={classes.root}>
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <ValidatorForm onSubmit={handleSelectDate}>
            <Box p="1rem">
              <Typography align="center" variant="h4" className={classes.title} color="secondary">Correo electrónico</Typography>
              <Typography variant="body2" align="justify" style={{ marginTop: "1rem" }}>Ingresá tu correo electrónico para poder registrarte en el sistema.</Typography>

              <TextValidator
                variant="outlined"
                margin="normal"
                fullWidth
                label="Correo electrónico"
                onChange={handleInputChange}
                name="email"
                type="email"
                validators={['required']}
                errorMessages={['El correo electrónico es requerido']}
                value={email}
              />
              <TextValidator
                variant="outlined"
                margin="normal"
                fullWidth
                label="Confirmación"
                onChange={handleInputChange}
                name="confirmEmail"
                type="email"
                validators={['isEmailMatch', 'required']}
                errorMessages={['Los correos deben ser iguales', 'La confirmación del correo electronico es requerido']}
                value={confirmEmail}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Continuar
              </Button>

            </Box>
          </ValidatorForm>
        </Container>
      </Box>
    </div>
  )
}

export default SetEmailScreen
